import { createRoot } from "react-dom/client";
import AppRouter from "./routers/AppRouter";
import cartReducer from "./reducers/cartReducer";
import { Provider } from "react-redux";
import { createStore } from "redux";

import { getContent } from "./firebase/content";
import { getImages } from "./firebase/images";
import { updateContent } from "./actions/cartAction";

import "bootstrap/dist/css/bootstrap.min.css";
import "firebaseui/dist/firebaseui.css";
import "normalize.css/normalize.css";
import "./styles/styles.scss";

const store = createStore(cartReducer);

Promise.all([getImages(), getContent()]).then(([images, content]) => {
  store.dispatch(updateContent(content, images));
});

const root = createRoot(document.getElementById("app"));

root.render(
  <Provider store={store}>
    <AppRouter />
  </Provider>
);
